export default __webpack_public_path__ + "static/media/noBooking.8312fc8d.png";